// extracted by mini-css-extract-plugin
export default {"question":"AdvicePopup_question__H-Ncn","question__icon":"AdvicePopup_question__icon__5lsQd","popup":"AdvicePopup_popup__zxXhp"};